.confirmationTextTypingContainer {
    margin-top: 10px;
    margin-bottom: 10px;
}